import { SearchIcon } from '../../../components/Icons'

export default function NoSearchResults() {
  return (
    <div className="flex-col h-[300px] justify-center text-center text-white gap-2 mt-16 overflow-auto">
      <SearchIcon className="m-auto mb-8" size={80} />
      <div className="text-3xl mb-2">No results found</div>
      <div className="text-lg opacity-80">
        We can't find any item matching
        {' '}
        <br />
        {' '}
        your search
      </div>
    </div>
  )
}
